import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

export interface UnmaskingLogPayload {
  targetUserId: string | number;
  fields: string[];
}

export interface UnmaskingLogResponse {
  data: {
    userId: string | number;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    email?: string;
    nhsNumber?: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class UnmaskingService {
  private url = `${environment.baseApiUrl}v2/unmasking-logs`;

  constructor(private http: HttpClient) {}

  async unmask(payload: UnmaskingLogPayload): Promise<UnmaskingLogResponse['data']> {
      const result = this.http.post<UnmaskingLogResponse>(this.url, payload)
      .pipe(
        map(response => response.data)
      );
      return firstValueFrom(result);
  }

  // GET /api/v2/unmasking-logs - for ADMIN
  getLogs(): Observable<any> {
    return this.http.get(this.url);
  }

  // GET /api/v2/unmasking-logs/:id - for ADMIN
  getLogById(id: string): Observable<any> {
    return this.http.get(`${this.url}/${id}`);
  }
}
